/** 特殊 UI 覆盖（按 menuId） */
export const MENU_RENDER_OVERRIDE = {
  2132: 'timeline',
  2133: 'certificate',
}

/** menuId → singleInfo 主键（后台 cmsType 配置不一致时的兜底） */
export const SINGLE_INFO_BY_MENU_ID = {
  2131: 13,
}

const ORG_STRUCTURE_NAME_PATTERN = /组织架构|organization/i

/** cmsType → render 模式 */
export const CMS_TYPE_RENDER_MAP = {
  0: 'empty',
  1: 'singleinfo',
  2: 'articleList',
  3: 'custom',
  4: 'downloadList',
  5: 'videoList',
  6: 'pictureGallery',
  7: 'config',
  8: 'textList',
}

/** 按后台 path 识别一级菜单类型（不依赖排序） */
const PATH_NAV_TYPE_RULES = [
  { type: 'news', patterns: [/xinwen/i, /news/i] },
  { type: 'about', patterns: [/guanyu/i, /about/i] },
  { type: 'partyBuilding', patterns: [/dangjian/i, /dangji/i, /partybuild/i, /party/i] },
  { type: 'construct', patterns: [/jianshe/i, /construct/i] },
  { type: 'business', patterns: [/yewu/i, /chanpin/i, /business/i] },
  { type: 'contact', patterns: [/lianxi/i, /contact/i] },
  { type: 'investor', patterns: [/touzi/i, /investor/i] },
]

const PARTY_BUILDING_NAME_PATTERN = /党的建设|party\s*building/i

const CONTACT_PANEL_NAME_PATTERN = /联系我们|contact\s*us/i

/** render 模式 → CmsPage 顶层组件名 */
export const RENDER_COMPONENT_MAP = {
  empty: 'CmsEmptyView',
  singleinfo: 'CmsSectionPage',
  timeline: 'CmsSectionPage',
  certificate: 'CmsSectionPage',
  pictureGallery: 'CmsSectionPage',
  custom: 'CmsSectionPage',
  articleList: 'CmsSectionPage',
  articleDetail: 'CmsSectionPage',
  contactPanel: 'CmsSectionPage',
  downloadList: 'InvestorPage',
  videoList: 'CmsSectionPage',
  textList: 'CmsSectionPage',
  businessDetail: 'VocationalPage',
  construct: 'ConstructPage',
  copyright: 'CopyrightPage',
}

/** 统一栏目壳页面可渲染的子内容模式 */
export const SECTION_CONTENT_MODES = [
  'empty',
  'singleinfo',
  'timeline',
  'certificate',
  'pictureGallery',
  'articleList',
  'articleDetail',
  'contactPanel',
  'videoList',
  'textList',
  'custom',
]

export function detectNavType(menuItem) {
  if (!menuItem) return 'menu'
  const name = String(menuItem.menuName || menuItem.menuNameEn || '')
  if (PARTY_BUILDING_NAME_PATTERN.test(name)) return 'partyBuilding'
  const path = String(menuItem.path || '')
  for (let i = 0; i < PATH_NAV_TYPE_RULES.length; i++) {
    const rule = PATH_NAV_TYPE_RULES[i]
    if (rule.patterns.some((pattern) => pattern.test(path))) {
      return rule.type
    }
  }
  return 'menu'
}

export function attachNavMeta(menuItem) {
  const navType = detectNavType(menuItem)
  return {
    ...menuItem,
    navMeta: {
      navType,
      isBusiness: navType === 'business',
      isContact: navType === 'contact',
      isNews: navType === 'news',
      isPartyBuilding: navType === 'partyBuilding',
    },
  }
}

export function resolveSingleInfoId(menuItem) {
  if (!menuItem) return null

  const menuId = Number(menuItem.menuId)
  if (SINGLE_INFO_BY_MENU_ID[menuId]) {
    return SINGLE_INFO_BY_MENU_ID[menuId]
  }

  if (menuItem.cmsLink !== undefined && menuItem.cmsLink !== null && menuItem.cmsLink !== '') {
    return menuItem.cmsLink
  }

  const path = String(menuItem.path || '')
  const pathMatch = path.match(/singleinfo\/(\d+)/i)
  if (pathMatch) return pathMatch[1]

  if (menuItem.query) {
    try {
      const query = typeof menuItem.query === 'string' ? JSON.parse(menuItem.query) : menuItem.query
      if (query.id !== undefined && query.id !== null && query.id !== '') {
        return query.id
      }
    } catch (e) {
      // ignore invalid query json
    }
  }

  const name = String(menuItem.menuName || menuItem.menuNameEn || '')
  if (ORG_STRUCTURE_NAME_PATTERN.test(name)) {
    return 13
  }

  return null
}

/** 首页新闻区固定 Tab（按 menuId，名称/归属可变） */
export const HOME_NEWS_TAB_MENU_IDS = [
  2143, // 新闻动态
  2128, // 通知公告
]

/** 通知公告类文章列表（标题样式，无缩略图） */
export const NOTICE_ARTICLE_MENU_IDS = [
  2128,
]

/** 当前语言下是否在前台导航隐藏 */
export function isNavHidden(menuItem, locale) {
  if (!menuItem) return true
  const isEn = String(locale || 'zh-CN').toLowerCase().startsWith('en')
  const flag = isEn ? menuItem.navHideEn : menuItem.navHide
  return flag === '1' || flag === 1
}

/** 当前语言下内容是否隐藏（0否 1是） */
export function isContentHidden(item, locale) {
  if (!item) return true
  const isEn = String(locale || 'zh-CN').toLowerCase().startsWith('en')
  const flag = isEn
    ? (item.contentShowFlagEn != null ? item.contentShowFlagEn : item.content_show_flag_en)
    : (item.contentShowFlag != null ? item.contentShowFlag : item.content_show_flag)
  return Number(flag) === 1
}

/** 按当前语言过滤前台可见的子菜单 */
export function filterVisibleNavMenus(menuList, locale) {
  return (menuList || []).filter((item) => !isNavHidden(item, locale))
}

function flattenVisibleMenuTree(nodes, locale, parentId = null, result = []) {
  ;(nodes || []).forEach((node) => {
    if (isNavHidden(node, locale)) return
    result.push({
      menuId: node.menuId,
      menuName: node.menuName,
      menuNameEn: node.menuNameEn,
      cmsType: node.cmsType,
      path: node.path,
      parentId,
    })
    if (node.children && node.children.length) {
      flattenVisibleMenuTree(node.children, locale, node.menuId, result)
    }
  })
  return result
}

/** 按页头可见菜单解析首页新闻区 Tab；父级或自身在当前语言下隐藏则不出现 */
export async function resolveHomeNewsTabs(menuAllFn, locale) {
  const navRes = await menuAllFn()
  const menuMap = new Map(
    flattenVisibleMenuTree(navRes.data || [], locale).map((item) => [Number(item.menuId), item])
  )
  return HOME_NEWS_TAB_MENU_IDS
    .map((menuId) => menuMap.get(Number(menuId)))
    .filter(Boolean)
}

/** 文章列表展示样式：card=带图卡片，text=标题列表（通知公告等） */
export function resolveArticleListLayout(menuItem) {
  if (!menuItem) return 'text'
  if (NOTICE_ARTICLE_MENU_IDS.includes(Number(menuItem.menuId))) return 'text'
  return 'card'
}

export function isSectionShellMode(mode) {
  return SECTION_CONTENT_MODES.includes(mode)
}

export function isContactPanelMenu(menuItem) {
  if (!menuItem) return false
  if (Number(menuItem.cmsType) === 7) return true
  const name = String(menuItem.menuName || menuItem.menuNameEn || '')
  return CONTACT_PANEL_NAME_PATTERN.test(name)
}

/** 二级菜单 → 右侧内容 render 模式（与一级栏目归属无关） */
export function resolveSubMenuRenderMode(menuItem) {
  if (!menuItem) return 'empty'

  const override = MENU_RENDER_OVERRIDE[menuItem.menuId]
  if (override) return override

  if (resolveSingleInfoId(menuItem)) return 'singleinfo'
  if (isContactPanelMenu(menuItem)) return 'contactPanel'

  const cmsType = Number(menuItem.cmsType)
  if (cmsType === 2) return 'articleList'
  if (cmsType === 8) return 'textList'
  if (cmsType === 6) return 'pictureGallery'
  if (cmsType === 5) return 'videoList'

  return CMS_TYPE_RENDER_MAP[cmsType] || 'empty'
}

export function resolveRenderMode(menuItem, options = {}) {
  if (options.singleId) return 'copyright'
  if (options.contentId) return 'articleDetail'
  if (options.businessId) return 'businessDetail'
  if (options.navType === 'business') return 'businessDetail'
  if (options.navType === 'partyBuilding' || options.navType === 'construct') return 'construct'
  if (!menuItem) return 'empty'

  return resolveSubMenuRenderMode(menuItem)
}

export function resolveSubMenuSelection(list, query = {}) {
  const items = list || []
  if (!items.length) {
    return { menuId: '', index: 0 }
  }

  if (query.menuId !== undefined && query.menuId !== null && query.menuId !== '') {
    const index = items.findIndex((item) => String(item.menuId) === String(query.menuId))
    if (index >= 0) {
      return { menuId: items[index].menuId, index }
    }
  }

  if (query.num !== undefined && query.num !== null && query.num !== '') {
    const raw = query.num
    const byMenuIdIndex = items.findIndex((item) => String(item.menuId) === String(raw))
    if (byMenuIdIndex >= 0) {
      return { menuId: items[byMenuIdIndex].menuId, index: byMenuIdIndex }
    }
    const num = Number(raw)
    if (!Number.isNaN(num) && items.length > num) {
      return { menuId: items[num].menuId, index: num }
    }
  }

  return { menuId: items[0].menuId, index: 0 }
}

export function buildCmsLocation({ parentId, menuId, id, contentId, search, singleId } = {}) {
  const query = {}
  if (parentId !== undefined && parentId !== null && parentId !== '') query.parentId = parentId
  if (menuId !== undefined && menuId !== null && menuId !== '') query.menuId = menuId
  if (id !== undefined && id !== null && id !== '') query.id = id
  if (contentId !== undefined && contentId !== null && contentId !== '') query.contentId = contentId
  if (search) query.search = search
  if (singleId !== undefined && singleId !== null && singleId !== '') query.singleId = singleId
  return { path: '/cms', query }
}

export function normalizeLegacyRoute(route) {
  const legacyPaths = ['/aboutUs', '/newsCenter', '/construct', '/contactUs', '/investor', '/vocational', '/copyright']
  if (!route || !legacyPaths.includes(route.path)) return null

  const query = {
    parentId: route.query.parentId,
    menuId: route.query.menuId || route.query.num,
    id: route.query.id,
    contentId: route.query.contentId,
    search: route.query.search,
  }

  if (route.path === '/copyright') {
    query.singleId = 18
  }

  Object.keys(query).forEach((key) => {
    if (query[key] === undefined || query[key] === null || query[key] === '') {
      delete query[key]
    }
  })

  return { path: '/cms', query }
}

export function findNavByType(navBarList, navType) {
  return (navBarList || []).find((item) => item.navMeta && item.navMeta.navType === navType)
}

export function isExternalMenu(item) {
  if (!item) return false
  if (item.isFrame === '0' || item.isFrame === 0) return true
  return /^https?:\/\//i.test(String(item.path || '').trim())
}



// WEBPACK FOOTER //
// ./src/utils/cmsNav.js